// Flag per evitare inizializzazione multipla
let appGlobalInitialized = false;

// Funzione per inizializzare il codice jQuery quando disponibile
function initializeAppGlobalJQueryCode(attempts = 0) {
    const maxAttempts = 100; // Massimo 5 secondi di tentativi
    
    // Verifica che jQuery sia disponibile
    if (typeof $ === 'undefined' || typeof jQuery === 'undefined') {
        if (attempts < maxAttempts) {
            setTimeout(() => initializeAppGlobalJQueryCode(attempts + 1), 50);
        } else {
            console.error('jQuery non disponibile dopo ' + maxAttempts + ' tentativi, abbandono inizializzazione app/_global');
        }
        return;
    }
    
    // Evita inizializzazione multipla
    if (appGlobalInitialized) {
        return;
    }
    
    // Inizializza il resto del codice jQuery per app/_global
    initializeAppGlobalJQueryFunctions();
    appGlobalInitialized = true;
}

// Funzioni che utilizzano jQuery - verranno chiamate quando jQuery è disponibile
function initializeAppGlobalJQueryFunctions() {
    $(document).ready(function () {
    initializeDesktopSearch();

    // === Mobile Search ===
    initializeMobileSearch();

    }); // Fine $(document).ready
} // Fine initializeAppGlobalJQueryFunctions

function initializeDesktopSearch() {
    var $form = $('.navbar-static-top .search');
    var $wrapper = $('#search-wrapper');
    var $input = $('#autocomplete-input');
    var $dropdown = $('#search-dropdown');
    var $dropdownBody = $('#search-dropdown-body');
    var desktopSearchTimer = null;
    var activeResultIndex = -1;

    if ($input.length === 0 || $dropdown.length === 0) {
        return;
    }

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(text || ''));
        return div.innerHTML;
    }

    function getGroupLabel(type) {
        if (type === 'client') {
            return 'Clienti';
        }
        if (type === 'project') {
            return 'Progetti';
        }
        if (type === 'contact') {
            return 'Contatti';
        }
        return 'Altro';
    }

    function getIconClass(type, recent) {
        if (type === 'client') {
            return 'fa-building-o';
        }
        if (type === 'project') {
            return 'fa-briefcase';
        }
        if (type === 'contact') {
            return 'fa-user';
        }
        if (recent) {
            return 'fa-clock-o';
        }
        return 'fa-file-text-o';
    }

    function setDropdownState(iconClass, message, stateClass) {
        var html =
            '<div class="' + stateClass + '">' +
                '<i class="fa ' + iconClass + '"></i>' +
                '<p>' + escapeHtml(message) + '</p>' +
            '</div>';
        $dropdownBody.html(html);
    }

    function openDropdown() {
        $form.addClass('search-open');
        $dropdown.show();
    }

    function closeDropdown() {
        $form.removeClass('search-open');
        $dropdown.hide();
        activeResultIndex = -1;
    }

    function getResultItems() {
        return $dropdownBody.find('.search-result-item');
    }

    function setActiveResult(index) {
        var $items = getResultItems();

        $items.removeClass('search-result-item-active').attr('aria-selected', 'false');

        if (!$items.length) {
            activeResultIndex = -1;
            return;
        }

        if (index < 0 || index >= $items.length) {
            activeResultIndex = -1;
            return;
        }

        activeResultIndex = index;
        var $activeItem = $items.eq(activeResultIndex);
        $activeItem.addClass('search-result-item-active').attr('aria-selected', 'true');

        var dropdownElement = $dropdown.get(0);
        var activeElement = $activeItem.get(0);
        if (dropdownElement && activeElement) {
            var itemTop = activeElement.offsetTop;
            var itemBottom = itemTop + activeElement.offsetHeight;
            var viewTop = dropdownElement.scrollTop;
            var viewBottom = viewTop + dropdownElement.clientHeight;

            if (itemTop < viewTop) {
                dropdownElement.scrollTop = itemTop;
            } else if (itemBottom > viewBottom) {
                dropdownElement.scrollTop = itemBottom - dropdownElement.clientHeight;
            }
        }
    }

    function moveActiveResult(step) {
        var $items = getResultItems();
        if (!$items.length) {
            return;
        }

        if (activeResultIndex === -1) {
            setActiveResult(step > 0 ? 0 : $items.length - 1);
            return;
        }

        var nextIndex = activeResultIndex + step;
        if (nextIndex < 0) {
            nextIndex = $items.length - 1;
        } else if (nextIndex >= $items.length) {
            nextIndex = 0;
        }

        setActiveResult(nextIndex);
    }

    function renderGroupedResults(items, isRecentMode) {
        if (!items || items.length === 0) {
            setDropdownState('fa-search', 'Nessun risultato', 'search-no-results');
            return;
        }

        var grouped = {};
        var orderedTypes = ['client', 'project', 'contact'];

        $.each(items, function (_, item) {
            var itemType = item.type || 'other';
            if (!grouped[itemType]) {
                grouped[itemType] = [];
            }
            grouped[itemType].push(item);
        });

        var html = '';
        $.each(orderedTypes, function (_, type) {
            var typeItems = grouped[type] || [];
            if (typeItems.length === 0) {
                return;
            }

            html += '<div class="search-group">';
            html += '<div class="search-group-header">' + getGroupLabel(type) + '</div>';

            $.each(typeItems, function (_, item) {
                var itemType = item.type || 'other';
                var icon = getIconClass(itemType, !!item.recent);
                var subtitle = item.subtitle ? '<span class="search-result-subtitle">' + escapeHtml(item.subtitle) + '</span>' : '';

                html += '<a href="' + escapeHtml(item.url) + '" class="search-result-item search-type-' + escapeHtml(itemType) + '">' +
                            '<span class="search-result-icon"><i class="fa ' + icon + '"></i></span>' +
                            '<span class="search-result-main">' +
                                '<span class="search-result-label">' + escapeHtml(item.label) + '</span>' +
                                subtitle +
                            '</span>' +
                        '</a>';
            });
            html += '</div>';
            delete grouped[type];
        });

        $.each(grouped, function (type, typeItems) {
            html += '<div class="search-group">';
            html += '<div class="search-group-header">' + getGroupLabel(type) + '</div>';
            $.each(typeItems, function (_, item) {
                var icon = getIconClass(type, !!item.recent);
                var subtitle = item.subtitle ? '<span class="search-result-subtitle">' + escapeHtml(item.subtitle) + '</span>' : '';

                html += '<a href="' + escapeHtml(item.url) + '" class="search-result-item search-type-' + escapeHtml(type) + '">' +
                            '<span class="search-result-icon"><i class="fa ' + icon + '"></i></span>' +
                            '<span class="search-result-main">' +
                                '<span class="search-result-label">' + escapeHtml(item.label) + '</span>' +
                                subtitle +
                            '</span>' +
                        '</a>';
            });
            html += '</div>';
        });

        if (isRecentMode) {
            html = '<div class="search-group-header">Aperti di recente</div>' + html;
        }

        $dropdownBody.html(html);
        activeResultIndex = -1;
    }

    function fetchDesktopResults(term) {
        setDropdownState('fa-spinner fa-spin', 'Caricamento...', 'search-loading-state');
        openDropdown();

        $.ajax({
            url: '/search',
            type: 'GET',
            data: { term: term },
            success: function (data) {
                renderGroupedResults(data, term.trim() === '');
            },
            error: function () {
                setDropdownState('fa-exclamation-circle', 'Errore nella ricerca', 'search-no-results');
            }
        });
    }

    $input.on('focus', function () {
        fetchDesktopResults('');
    });

    $input.on('input', function () {
        var term = $(this).val().trim();

        if (desktopSearchTimer) {
            clearTimeout(desktopSearchTimer);
        }

        if (term.length < 2) {
            fetchDesktopResults('');
            return;
        }

        desktopSearchTimer = setTimeout(function () {
            fetchDesktopResults(term);
        }, 300);
    });

    $input.on('keydown', function (e) {
        if (e.keyCode === 40 || e.keyCode === 38) {
            e.preventDefault();

            if (!$dropdown.is(':visible')) {
                var currentTerm = $input.val().trim();
                fetchDesktopResults(currentTerm.length < 2 ? '' : currentTerm);
            }

            moveActiveResult(e.keyCode === 40 ? 1 : -1);
            return false;
        }

        if (e.keyCode === 13) {
            e.preventDefault();
            var $items = getResultItems();
            if (!$items.length) {
                return false;
            }

            var $targetItem;
            if (activeResultIndex >= 0 && activeResultIndex < $items.length) {
                $targetItem = $items.eq(activeResultIndex);
            } else {
                $targetItem = $items.first();
            }

            if ($targetItem.length) {
                window.location.href = $targetItem.attr('href');
            }
            return false;
        }

        if (e.keyCode === 27) {
            closeDropdown();
            return false;
        }
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest($wrapper).length === 0) {
            closeDropdown();
        }
    });

    $dropdownBody.on('mouseenter', '.search-result-item', function () {
        var $items = getResultItems();
        var hoveredIndex = $items.index(this);
        setActiveResult(hoveredIndex);
    });

    $(document).on('keydown', function (e) {
        var activeTag = (document.activeElement && document.activeElement.tagName) ? document.activeElement.tagName.toLowerCase() : '';
        var isTypingField = activeTag === 'input' || activeTag === 'textarea' || (document.activeElement && document.activeElement.isContentEditable);

        if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey && !isTypingField) {
            e.preventDefault();
            $input.focus();
        }
    });
}

// Mobile search initialization
function initializeMobileSearch() {
    var $overlay = $('#mobile-search-overlay');
    var $input = $('#mobile-autocomplete-input');
    var $results = $('#mobile-search-results');
    var $clearBtn = $('.mobile-search-clear');
    var mobileSearchTimer = null;

    // Open mobile search overlay
    $(document).on('click', '.mobile-search-toggle', function(e) {
        e.preventDefault();
        $overlay.fadeIn(200);
        // Prevent body scroll
        $('body').css('overflow', 'hidden');
        // Carica i risultati recenti e focus input
        loadRecentResults();
        setTimeout(function() {
            $input.focus();
        }, 250);
    });

    // Close mobile search overlay
    $(document).on('click', '.mobile-search-close', function(e) {
        e.preventDefault();
        closeMobileSearch();
    });

    // Close on Escape key
    $input.on('keydown', function(e) {
        if (e.keyCode === 27) { // Escape
            closeMobileSearch();
        }
        if (e.keyCode === 13) { // Enter - prevent form submission
            e.preventDefault();
            return false;
        }
    });

    // Clear button
    $clearBtn.on('click', function(e) {
        e.preventDefault();
        $input.val('').focus();
        $clearBtn.hide();
        showPlaceholder();
    });

    // Input handler with debounce
    $input.on('input', function() {
        var term = $(this).val().trim();

        // Show/hide clear button
        if (term.length > 0) {
            $clearBtn.show();
        } else {
            $clearBtn.hide();
        }

        // Clear previous timer
        if (mobileSearchTimer) {
            clearTimeout(mobileSearchTimer);
        }

        if (term.length < 2) {
            loadRecentResults();
            return;
        }

        // Show loading
        showLoading();

        // Debounce search
        mobileSearchTimer = setTimeout(function() {
            performMobileSearch(term);
        }, 300);
    });

    function closeMobileSearch() {
        $overlay.fadeOut(200);
        $('body').css('overflow', '');
        $input.val('');
        $clearBtn.hide();
        showPlaceholder();
    }

    function showPlaceholder() {
        loadRecentResults();
    }

    function loadRecentResults() {
        $.ajax({
            url: '/search',
            type: 'GET',
            data: { term: '' },
            success: function(data) {
                if (data && data.length > 0) {
                    var html = '<div class="mobile-search-recent-header">' +
                                   '<i class="fa fa-clock-o"></i> Aperti di recente' +
                               '</div>';
                    $.each(data, function(i, item) {
                        var icon = 'fa-clock-o';
                        if (item.type === 'client') { icon = 'fa-building-o'; }
                        else if (item.type === 'project') { icon = 'fa-briefcase'; }
                        else if (item.type === 'contact') { icon = 'fa-user'; }
                        html += '<a href="' + item.url + '" class="mobile-search-result-item mobile-recent-item">' +
                                    '<i class="fa ' + icon + ' mobile-recent-icon"></i> ' +
                                    escapeHtml(item.label) +
                                '</a>';
                    });
                    $results.html(html);
                } else {
                    $results.html(
                        '<div class="mobile-search-placeholder">' +
                            '<i class="fa fa-search"></i>' +
                            '<p>' + ($input.attr('placeholder') || 'Search...') + '</p>' +
                        '</div>'
                    );
                }
            },
            error: function() {
                $results.html(
                    '<div class="mobile-search-placeholder">' +
                        '<i class="fa fa-search"></i>' +
                        '<p>' + ($input.attr('placeholder') || 'Search...') + '</p>' +
                    '</div>'
                );
            }
        });
    }

    function showLoading() {
        $results.html(
            '<div class="mobile-search-loading">' +
                '<i class="fa fa-spinner fa-spin"></i>' +
            '</div>'
        );
    }

    function performMobileSearch(term) {
        $.ajax({
            url: '/search',
            type: 'GET',
            data: { term: term },
            success: function(data) {
                if (data && data.length > 0) {
                    var html = '';
                    $.each(data, function(i, item) {
                        html += '<a href="' + item.url + '" class="mobile-search-result-item">' +
                                    escapeHtml(item.label) +
                                '</a>';
                    });
                    $results.html(html);
                } else {
                    $results.html(
                        '<div class="mobile-search-no-results">' +
                            '<i class="fa fa-search"></i>' +
                            '<p>Nessun risultato</p>' +
                        '</div>'
                    );
                }
            },
            error: function() {
                $results.html(
                    '<div class="mobile-search-no-results">' +
                        '<i class="fa fa-exclamation-circle"></i>' +
                        '<p>Errore nella ricerca</p>' +
                    '</div>'
                );
            }
        });
    }

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(text));
        return div.innerHTML;
    }
}

// Avvia l'inizializzazione
initializeAppGlobalJQueryCode();

// Avvia l'inizializzazione quando il DOM è pronto (backup)
document.addEventListener('DOMContentLoaded', function() {
    initializeAppGlobalJQueryCode();
});

